import React from 'react'
// import './heading.scss'
import * as styles from './heading.module.css'

function Heading({ heading, children }) {
    switch (heading) {
        case 'H1':
            return <h1 className={styles.heading1}>{children}</h1>
        case 'H2':
            return <h2 className={styles.heading3}>{children}</h2>
        case 'H3':
            return <h3 className={styles.heading3}>{children}</h3>
        case 'H4':
            return <h4 className={styles.heading4}>{children}</h4>
        case 'H5':
            return <h5 className={styles.heading5}>{children}</h5>
        case 'H6':
            return <h6>{children}</h6>
        case 'P':
            return <p className={styles.heading3}>{children}</p>
        default:
            return <h2 className={styles.heading2}>{children}</h2>
    }
}

export default Heading
